import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, css } from "styled-components";

export const FomrmLoginWrap = styled.div`
	padding: 0;
`;

export const FomrmLoginInput = styled.input`
	color: #6b7280;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	display: flex;
	height: 56px;
	padding: 0px 16px;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	font-family: inherit;
	color: #111827;
	@supports (-webkit-overflow-scrolling: touch) {
		& {
			font-size: 16px;
		}
	}
`;
export const FomrmLoginInput2 = styled(FomrmLoginInput)`
	margin-bottom: 8px;
`;

export const ForgotYourPassword = styled.div`
	color: #035d9d;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	margin-bottom: 16px;
	cursor: pointer;

	&:hover {
		font-weight: 600;
	}
`;

export const FomrmLoginButton = styled.button<{ $loading?: boolean }>`
	cursor: ${({ $loading }) => ($loading ? "not-allowed" : "pointer")};
	border-radius: 8px;
	background: ${({ $loading }) => ($loading ? "#cccccc" : "#035D9D")};
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	color: #fff;
	margin-bottom: 16px;
	opacity: ${({ $loading }) => ($loading ? 0.6 : 1)};
	pointer-events: ${({ $loading }) => ($loading ? "none" : "auto")};
	width: 100%;
	border: none;
`;
export const FomrmLoginCreateOneWrap = styled.div`
	justify-content: center;
	display: flex;
`;
export const FomrmLoginCreateOneText = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
`;
export const FomrmLoginCreateOne = styled.div`
	color: #035d9d;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	margin-left: 4px;
	cursor: pointer;

	&:hover {
		font-weight: 600;
	}
`;

export const ErrorNotiLogin = styled.div`
	color: #dc2626;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
	margin-bottom: 16px;
`;
export const NoteErrorNotiLogin = styled.div`
	height: 8px;
`;

export const DropdownContainerFireBase = styled.div<{ disable?: boolean }>`
	position: relative;
	border-radius: 8px;
	border: 1px solid var(--Divider-On-White, #e5e7eb);
	pointer-events: ${({ disable }) => (disable ? "none" : "")};
	// margin-bottom:16px;
	//   width: 100%;
	@media screen and (max-width: 768px) {
		width: 100%;
		border: none;
	}
`;
export const DropdownContainerFireBasev2 = styled(DropdownContainerFireBase)`
	@media screen and (max-width: 768px) {
	width: auto;
	}
`;
export const DropdownContainerSelectApp = styled.div<{ disable?: boolean }>`
	position: relative;
	// border-radius: 8px;
	border-left: 1px solid var(--Divider-On-White, #e5e7eb);
	pointer-events: ${({ disable }) => (disable ? "none" : "")};
	// margin-bottom:16px;
	//   width: 100%;
	margin: -12px;
	padding: 12px 0 12px 12px;
	cursor: pointer;
	@media screen and (max-width: 768px) {
		margin: 0;
	}
`;

export const DropdownHeaderFireBase = styled.div`
	cursor: pointer;
	display: flex;
	padding: 4px 6px 4px 4px;

	justify-content: center;
	align-items: center;
	width: 88px;
	margin-right: 12px;
	@media screen and (max-width: 768px) {
		justify-content: space-between;
		width: 100%;
	}
`;
export const DropdownHeaderFireBasev2 = styled(DropdownHeaderFireBase)`
	@media screen and (max-width: 768px) {
		width: 50px;
	}
`;
export const DropdownHeaderSelectApp = styled.div`
	display: flex;
	padding: 4px 6px 4px 4px;

	justify-content: space-between;
	align-items: center;
	min-width: 88px;
	margin-right: 12px;
	@media screen and (max-width: 768px) {
		justify-content: space-between;
		width: 80px;
		padding: 4px 0px 4px 4px;
		margin-right: 0px;
	}
`;

export const DropdownHeaderFireBaseDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 500;
`;
export const DropdownHeaderSelectAppDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 500;
	margin-right: 4px;
	@media screen and (max-width: 768px) {
		display:none;
	}
`;
export const DropdownHeaderSelectAppDivRes = styled.div`
display:none;
	
	@media screen and (max-width: 768px) {
		display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 500;
	margin-right: 4px;
	}
`;
export const DropdownListContainerFireBase = styled.div`
	position: absolute;
	max-height: 200px;
	overflow-y: overlay;
	border: 1px solid rgb(204, 204, 204);
	border-radius: 12px;
	background-color: white;
	left: -8px;
	bottom: 39px;
	overflow-x: unset;
`;
export const DropdownListContainerSelectApp = styled.div`
	position: absolute;
	max-height: 200px;
	overflow-y: overlay;
	border: 1px solid rgb(204, 204, 204);
	border-radius: 12px;
	background-color: white;
	right: 0;
	bottom: 39px;
	overflow-x: unset;
`;

export const DropdownListFireBase = styled.ul`
	list-style: none;
	padding: 4px;
	margin: 0;
	width: 200px;
`;

export const ListItemFireBase = styled.li`
	display: flex;
	align-items: center;
	padding: 8px;
	cursor: pointer;

	&:hover {
		background-color: #f0f0f0;
	}
`;

export const FlagImageFireBase = styled.img`
	width: 24px;
	height: 24px;
	margin-right: 8px;
`;
export const FlagImageFireBaseSpan = styled.span`
	display: none;
	@media screen and (max-width: 768px) {
		display: inline;
	}
`;

export const FomrmLoginInputPhoneNumberWrap = styled.div`
	width: 100%;
	padding: 12px 16px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
`;
export const FomrmLoginInputPhoneNumberWrapv2 = styled(FomrmLoginInputPhoneNumberWrap)`
	width: 100%;
	padding: 12px 16px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 16px;
	@media screen and (max-width: 768px) {
		border-radius: 0 0 8px 8px;
		border: 1px solid #e5e7eb;
		border-top: none;
	}
`;

export const FomrmLoginInputPhoneNumberInner = styled.div`
	display: flex;
`;
export const FomrmLoginInputPhone = styled.input`
	border: none;
	outline: none;
	border: 0px solid #fff;
	margin-left: 8px;
	width: 75%;
	font-family: inherit;
	@supports (-webkit-overflow-scrolling: touch) {
		& {
			font-size: 16px;
		}
	}
`;
export const SeledctApp = styled.div<{ disable?: boolean }>`
	display: flex;
	pointer-events: ${({ disable }) => (disable ? "none" : "")};
	background-color: #fff;
	@media screen and (max-width: 768px) {
		margin: -11px 0px;
	}
`;

export const SelectWrapper = styled.select`
	display: flex;
	align-items: center;
	padding-left: 12px;
	border: none;
	border-left: 1px solid #e5e7eb;
`;

export const Label = styled.label`
	margin-bottom: 8px;
	font-weight: bold;
`;

export const Select = styled.select`
	padding: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 16px;
`;
